module.exports = __webpack_public_path__ + "img/vertical_7_6_7042.139cc020.png";